<template>
  <Confirm
    :value="value"
    v-on="$listeners"
    title="Delete group"
    :confirmBtn="{ text: 'Yes, delete' }"
  >
    <p>
      This action will delete
      <span class="has-text-weight-bold">{{ groupItem.group.name }}</span>
      and everything related to it. However, it will not effect computer
      packages, meaning that what is installed will stay installed.
    </p>
    <p>Including:</p>
    <ul>
      <li>Schedules</li>
      <li>Packages</li>
    </ul>
  </Confirm>
</template>

<script>
export default {
  components: { Confirm: () => import("@/components/main/Confirm.vue") },
  props: { groupItem: Object, value: Boolean }
};
</script>
